<template>
	<div class="plans">
		<div class="seats desktop">
			<ul>
				<!-- <li v-for="(selectedSection, x) in gamePlanName" :key="x">
				<p>{{selectedSection.replace(/_/g, ' ')}}</p>
			</li> -->

			<li  v-for="(seats, index) in seatingPlan" :key="index"  :class="selectedPlanType">
				<!-- <template v-for="(plan, i) in gamePlanName" :key="i" > v-if="plan.replace(/_/g, ' ') == seats.seat" , disabled: (plan.replace(/_/g, ' ') != seats.seat)-->
				<a href="#"   :class=" { active: (this.sectionPlan == seats.seat),  disabled: (seats.section == 'off')}" class="seatPlans" @click="getPlansectionName(seats.seat, $event)" >
					<span class="color" :style="seats.color">color</span>
					<span class="seat">{{seats.seat}}</span>
				</a>
				<!-- </template> -->


			</li>
			<!--   -->
			<!--, disabled: (this.sectionPlan != seats.seat) -->
		</ul>
	</div>
</div>
</template>
<script>
export default {
	name: "SeatingChart",
	emit :['seatPlanSelected'],
	props: ['selectedPlanType', 'gamePlanName', 'sectionName'],
	data() {
		return {
			activeSeats: false,
			sectionPlan: "",
			//preSelectedPlans: this.gamePlanName,
			seatingPlan: [
				{
					color: "background:#273074",
					seat: "Club Box Home Plate",
					section: "off"
				},
				{
					color: "background:#5C518F",
					seat: "Club Box Infield",
					section: "off"
				},
				{
					color: "background:#989ABA",
					seat: "Club Box Outfield",
					section: "off"
				},
				{
					color: "background:#19BCB9",
					seat: "Field Box Home Plate",
					section: "off"
				},
				{
					color: "background:#007EC3",
					seat: "Field Box Infield",
					section: "off"
				},
				{
					color: "background:#386476",
					seat: "Field Box Outfield",
					section: "off"
				},
				{
					color: "background:#A83948",
					seat: "Terrace Box Home Plate",
					section: "off"
				},
				{
					color: "background:#F9A89A",
					seat: "Terrace Box Infield",
					section: "off"
				},
				{
					color: "background:#9FC049",
					seat: "Terrace Box Outfield",
					section: "off"
				},
				{
					color: "background:#B6C777",
					seat: "Terrace Box Corner",
					section: "off"
				},
				{
					color: "background:#EF4164",
					seat: "Terrace Reserved Preferred",
					section: "off"
				},
				{
					color: "background:#6D0617",
					seat: "Terrace Reserved Infield",
					section: "off"
				},
				{
					color: "background:#0D712E",
					seat: "Terrace Reserved Outfield",
					section: "off"
				},
				{
					color: "background:#003D09",
					seat: "Terrace Reserved Outfield Corner",
					section: "off"
				},
				{
					color: "background:#044B44",
					seat: "Upper Box Infield",
					section: "off"
				},
				{
					color: "background:#1F7D78",
					seat: "Upper Box Midfield",
					section: "off"
				},
				{
					color: "background:#90C2BD",
					seat: "Upper Box Outfield",
					section: "off"
				},
				{
					color: "background:#068667",
					seat: "Upper Reserved Infield",
					section: "off"
				},
				{
					color: "background:#8DCD9F",
					seat: "Upper Reserved Outfield",
					section: "off"
				},
				{
					color: "background:#2E3192",
					seat: "Bullpen Box Front Row",
					section: "off"
				},
				{
					color: "background:#2E3192",
					seat: "Bullpen Box",
					section: "off"
				},
				{
					color: "background:#FFDA3F",
					seat: "Budweiser Bleachers",
					section: "off"
				},
			],
		};
	},
	watch: {
		gamePlanName() {

			for (let j = 0; j < this.seatingPlan.length; j++) {
				this.seatingPlan[j].section = "off";
				for (let i = 0; i < this.gamePlanName.length; i++) {
					let planName = this.gamePlanName[i].replace(/_/g, ' ');

					if(this.seatingPlan[j].seat == planName){

						this.seatingPlan[j].section = "on";
					}

				}

			}
			this.sectionPlan = this.sectionName;

		}
	},
	mounted() {
		// setTimeout(() => {
		// this.planType = "daily";
		this.sectionPlan = "Club Box Home Plate";
		// this.getPricingInfo();
		// }, 5000);
	},
	methods:{
		sayHello(){
			// alert("hello");
		},
		getPlansectionName(sectionName, event){

			event.preventDefault();
			this.sectionPlan = sectionName;
			this.$emit('selectedSeatPlan',  {'sectionName': sectionName});
		}
		//
	},

};
</script>
<style lang="scss" scoped>
.plans{
	display: flex;
	justify-content:center;
	align-items:center;
}
.seats{
	ul{
		columns: 2;
		li{
			list-style:none;
			// padding: 10px 0px;
			position: relative;
			@include media-breakpoint-down(sm) {
				padding: 5px 0px;
			}


		}
	}
	.seatPlans{
		display:flex;
		flex-direction: row;
		align-items:center;
		// justify-content: space-between;
	}
	a{
		text-decoration:none;
		font-family: 'Verlag Condensed Bold';
		font-style: normal;
		font-weight: 325;
		font-size: 14px;
		line-height: 120%;
		position: relative;

		padding:10px 0px;
		color: #000 !important;
		&.active{
			background: #CC3433;
			padding:10px 0px;
			// a{
			color:white !important;
			// }
		}
		@include media-breakpoint-down(sm) {
			font-size: 10px;
			// justify-content:center;
		}
		@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
			font-size: 12px;
		}
	}
	.disabled{
		display:none;
		pointer-events: none;
		color: #ECECEC !important;
	}
	.seat{
		// text-indent: 50px;
		    // width: 185px;
			// @include media-breakpoint-down(sm) {
			// 	width: auto;
			// }
			// @media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
			// 	width: auto;
			// }

	}
	.color{
		width:20px !important;
		height:20px ;
		margin-right:3px;
		font-size:12px;
		color: transparent !important;
		// margin-left:2px;
		@include media-breakpoint-down(sm) {
			width:12px!important;
			height:12px;
		}
		// position: absolute;
	}
}
</style>
